import { UserService } from '../../../../services/user.service';
import { GenderEnum } from '../../../../app.constants';
var GenderPerAgeChartComponent = /** @class */ (function () {
    function GenderPerAgeChartComponent(userService) {
        this.userService = userService;
    }
    GenderPerAgeChartComponent.prototype.ngOnInit = function () {
        this.leftXAxis = [];
        for (var i = this.maxPercent; i >= 0; i--) {
            this.leftXAxis.push(i);
        }
        this.rightXAxis = this.leftXAxis.slice();
        this.rightXAxis.reverse();
    };
    Object.defineProperty(GenderPerAgeChartComponent.prototype, "barMaleColor", {
        get: function () {
            return this.userService.chartColors[GenderEnum.MALE];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GenderPerAgeChartComponent.prototype, "barFemaleColor", {
        get: function () {
            return this.userService.chartColors[GenderEnum.FEMALE];
        },
        enumerable: true,
        configurable: true
    });
    return GenderPerAgeChartComponent;
}());
export { GenderPerAgeChartComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-demographics/gender-per-age-chart/gender-per-age-chart.component.ts.pre-build-optimizer.js